import { render, staticRenderFns } from "./CreatePemutihan.vue?vue&type=template&id=55eabe32"
import script from "./CreatePemutihan.vue?vue&type=script&lang=js"
export * from "./CreatePemutihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports